import api from "@/lib/api";

// GENERAL
export const getGeneralSettings = async () => {
  const res = await api.get("/settings/general");
  return res.data;
};

export const updateGeneralSettings = async (payload) => {
  const res = await api.post("/settings/general", payload);
  return res.data;
};

// SEO
export const getSeoSettings = async () => {
  const res = await api.get("/settings/seo");
  return res.data;
};

export const updateSeoSettings = async (payload) => {
  const res = await api.post("/settings/seo", payload);
  return res.data;
};

// EMAIL
export const getEmailSettings = async () => {
  const res = await api.get("/settings/email");
  return res.data;
};

export const updateEmailSettings = async (payload) => {
  const res = await api.post("/settings/email", payload);
  return res.data;
};

// ADVANCED
export const getAdvancedSettings = async () => {
  const res = await api.get("/settings/advanced");
  return res.data;
};

export const updateAdvancedSettings = async (payload) => {
  const res = await api.post("/settings/advanced", payload);
  return res.data;
};

// MAINTENANCE
export const getMaintenanceSettings = async () => {
  const res = await api.get("/settings/maintenance");
  return res.data;
};

export const updateMaintenanceSettings = async (payload) => {
  const res = await api.post("/settings/maintenance", payload);
  return res.data;
};

// SECURITY
export const getSecuritySettings = async () => {
  const res = await api.get("/settings/security");
  return res.data;
};

export const updateSecuritySettings = async (payload) => {
  const res = await api.post("/settings/security", payload);
  return res.data;
};